<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t("home.header.Gmail") }}</p><img src="/img/up-arrow.7f2fb856.svg" alt="logo" class="right-arrow"><a
                                href="#">{{ $t('Advance.Channels.Email.Gmail.EnableImap.tittle') }}</a>
                        </div>
                       

                        <div class="Introduction-details text-align-left">
                            <h1>{{ $t('Advance.Channels.Email.Gmail.EnableImap.gmailInbox') }}</h1>
                        </div>
                        <div class="channels-info break-word code-info">
                            <div class="channels-title">
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.step1') }}</strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.settings') }}</p>
                                <p><img alt="gmail_inbox" src="../../../../../../assets/images/gmail_inbox.png"
                                        class="max-img">
                                </p>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.step2') }}</strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.allSettings') }}</p>
                                <p><img alt="gmail_quick_settings"
                                        src="../../../../../../assets/images/gmail_quick_settings.png" class="max-img"></p>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.step3') }}</strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.forwarding') }}</p>
                                <p><img alt="gmail_imap_settings"
                                        src="../../../../../../assets/images/gmail_imap_settings.png" class="max-img"></p>
                                <p><strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.step4') }}</strong>{{ $t('Advance.Channels.Email.Gmail.EnableImap.chooseImap') }}</p>
                                <p><img alt="gmail_enable_imap" src="../../../../../../assets/images/gmail_enable_imap.png"
                                        class="max-img"></p>
                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.Channels.Email.Gmail.EnableImap.editPage') }}</a>
                            </div> -->
                            <p>{{ $t('Advance.Channels.Email.Gmail.EnableImap.lastUpdatedOn') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.EnableImap.date') }} </span> {{ $t('Advance.Channels.Email.Gmail.EnableImap.by') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.EnableImap.hrichaShandily') }}
                                </span></p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('Advance.Channels.Email.Gmail.EnableImap.previous') }}</p>



                                    <router-link to="/docs/product/channels/email/forward-email"
                                        class="introduction-account">
                                        <span>{{ $t('Advance.Channels.Email.Gmail.EnableImap.side') }}</span> {{ $t('Advance.Channels.Email.Gmail.EnableImap.forwardEmail') }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('Advance.Channels.Email.Gmail.EnableImap.next') }}</p>


                                    <router-link to="/docs/product/channels/email/gmail/less-secure-access">
                                        {{ $t('Advance.Channels.Email.Gmail.EnableImap.imap') }} <span>{{ $t('Advance.Channels.Email.Gmail.EnableImap.arrow') }}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
import MainContent from "@/components/MainContent.vue";

export default {
    name: 'enable-imap',
    data() {
        return {
            isToggle: false
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        MainContent
    },
    methods: {
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>
